import {useQuery} from '@tanstack/react-query';
import type {WorkstreamDraftPolicy} from 'client';
import {
  fetchWorkstreamDraftPolicy,
  workstreamDraftPolicyQueryKey,
} from 'helpers/workstreamDraftPolicy';

export function useWorkstreamDraftPolicy(options?: {enabled?: boolean}) {
  return useQuery<WorkstreamDraftPolicy>({
    queryKey: workstreamDraftPolicyQueryKey,
    queryFn: fetchWorkstreamDraftPolicy,
    enabled: options?.enabled ?? true,
  });
}
